import { BaseModel } from "./base.model";

export class MultimediaModel {
  url:  string
  type:  string
  constructor(obj: any = null) {
    this.type = obj?.type
    this.url = obj?.url
  }
}

class PageMessages {
  title: string
  description: string
  is_enabled: boolean

  constructor(obj: any = null) {
    this.title = obj?.title || ""
    this.description = obj?.description || ""
    this.is_enabled = obj?.is_enabled || false
  }
}

class PagesData {
  payment_finished: PageMessages
  orden_information: PageMessages

  constructor(obj: any = null) {
    this.payment_finished = new PageMessages(obj?.payment_finished);
    this.orden_information = new PageMessages(obj?.orden_information);
  }
}

export class SettingTotemModel {
  customer_identification: boolean;
  beneficiary_identification: boolean;
  pages: PagesData
  shopping_cart_cloud: boolean;
  show_survey: boolean;

  constructor(obj: any = null) {
    this.customer_identification = obj?.customer_identification || false
    this.beneficiary_identification = obj?.beneficiary_identification || false
    this.pages = new PagesData(obj?.pages)
    this.shopping_cart_cloud = obj?.shopping_cart_cloud || false
    this.show_survey = obj?.show_survey || false
  }
}

export class TotemModel extends BaseModel {
  code: string
  image_url: string
  video_url: string
  url: string
  multimedia: MultimediaModel[]
  minimarket: boolean
  scanner: boolean
  save_screen_text: string
  terminal_id: string
  settings: SettingTotemModel

  constructor(obj: any = null) {
    super(obj)
    this.code = obj?.code
    this.image_url = obj?.image_url
    this.video_url = obj?.video_url
    this.url = obj?.url
    this.multimedia =  obj?.multimedia ? obj?.multimedia?.map((i: any) => (new MultimediaModel(i))) : []
    this.minimarket = obj?.minimarket || false
    this.scanner = obj?.scanner || false
    this.save_screen_text = obj?.save_screen_text,
    this.terminal_id = obj?.terminal_id
    this.terminal_id = obj?.terminal_id
    this.settings = new SettingTotemModel(obj?.settings)
  }
}


export type TotemOrientation = 'portrait' | 'landscape';
